export const APP_NAME = 'wake.lol';
export const BASE_URL = 'https://wake.lol/';
export const SKEOH_URL = 'https://skeoh.com/?utm_source=wake.lol';
export const FEATURES = 'width=300,height=200';
export const ID_BELOW_THE_FOLD = 'below-the-fold';
export const DEFAULT_THEME_COLOR = '#bef5a3'; // hsl(100, 80%, 80%)
